enum CardTypes {
	RED_CARD = "red_card",
	GREEN_CARD = "green_card",
	YELLOW_CARD = "yellow_card",
}

export { CardTypes };
